import { render } from "./SVGLogo.vue?vue&type=template&id=60764cf0"
const script = {}

import "./SVGLogo.vue?vue&type=style&index=0&id=60764cf0&lang=scss"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__